import Vue from 'vue';

export default {
	updateConsumerImage(state, image) {
		Vue.set(state.consumer.profilePhoto, 'image', image);
	},
};
